import {Campagne} from '../campagne';

export class UserEnEchange {
    constructor(
        public id?: number,
        public email?: string,
        public codePaysUniversite?: string,
        public nomUniversiteOrigine?: string,
        public typeEchange?: string,
        public nom?: string,
        public prenom?: string,
        public dateNaissance?: any,
        public typeEtudiant?: number,
        public campagne?: Campagne,
        // rempli dynamiquement
        public paysUniversite?: string,
    ) { }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/user-en-echange/user-en-echange.model.ts